import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import BillMismatchTable from './BillMismatchTable';


const BillMismatchAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM Do, YYYY')}
    icon={<BarnyardIcon icon={['fa', 'not-equal']} className='DiscussCard__replyIcon dea' />}
    title={(
      <div>
        <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
          {alert.buyer.name}
        </Link>
        {alert.value.supplier_name ? (
          <>
            {' '} placed an order from {' '}
            <strong className='u-colorRed'>
              {alert.value.supplier_name}
            </strong>
          </>
        ) : <> {' '} placed an order {' '} </> }
        {' '} that was not billed to {' '}
        <strong className='u-colorRed'>
          {alert.value.address}
        </strong>
      </div>
    )}
    content={(
      <BillMismatchTable
        includeExport={true}
        orders={alert.value.orders}
      />
    )}
    {...other}
  />
);

BillMismatchAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default BillMismatchAlert;
